import { $http } from '@/utils';
const _iotCenter = true ? '/iot-center' : '';

// eslint-disable-next-line import/no-anonymous-default-export
export default {

    //查询每个电表月内每天的日冻结数据
    getElectricFreezeList(data) {
        return $http.get(_iotCenter + '/query/meter/freeze/month/day', data);
    },
    //电表数据实时召测
    getElectricMake(id){
        return $http.post(_iotCenter + '/call/meter/'+id+'/freeze/day',{},{},{
            isBackCode: true
        });
    },
    //查询历史曲线

    getElectricHistoryList(data) {
        return $http.get(_iotCenter + '/query/meter/his', data);
    },


    //召测历史曲线
    getElectricHistory(data){
        return $http.post(_iotCenter + '/call/meter/'+data.meterId+'/his',{

        },{
            baseTime:data.time
        },{
            isBackCode: true
        });
    },
    //查询需量列表
    getElectricDemandList(data) {
        return $http.get(_iotCenter + '/query/meter/his', data);
    },
    //导出集中器日冻结数据
    exportElectricList(data){
        return $http.get(_iotCenter + '/query/meters/exportExcelFreezeDay', data,{ request:{
                responseType:'blob'
            },
            isExport:true,
            isBackCode:true});
    },
    //查询集中器日冻结数据列表
    getGatewayList(data) {
        return $http.get(_iotCenter + '/query/device/freeze/day', data);
    },

    //查询集中器实时数据
    getGatewayRealList(data) {
        return $http.get(_iotCenter + '/query/device/current/'+data.page, data);
    },
    //日冻结召测 - 批量数据
    electricMakeBatch(data){
        return $http.post(_iotCenter + '/call/meters/freeze/day', data, {}, {
            isBackCode: true
        });
    },

    //需量数据列表
    getDemandList(data) {
        return $http.get(_iotCenter + '/query/device/freeze/queryDemand', data);
    },
    //需量数据补招
    demandMakeBatch(data){
        return $http.post(_iotCenter + '/call/meter/freeze/demand', data,{}, {
            isBackCode: true
        });
    },

    //集中器实时数据召测
    realTimeElectricMake(data){
        return $http.post(_iotCenter + '/call/meters/real', data, {}, {
            isBackCode: true
        });
    },
    //获取通道日志
    getLogList(data){
        // return $http.get(_iotCenter + '/log/device/'+ data.deviceId +'/interactive', data);
        return $http.get(_iotCenter + '/log/device/'+ data.deviceId +'/interactive/new', data);
    }
}
